export default __webpack_public_path__ + "static/media/conference.b90bfff1.svg";